var _defs, _g, _path, _path2, _path3, _polygon, _polygon2, _polygon3, _path4, _polygon4, _polygon5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnRoomWidth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 225.88 142.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#ea8b77;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:#59595b;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 190.33,
    y1: 10.69,
    x2: 225.88,
    y2: 10.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db7860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed7159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 11.01,
    y1: 65.28,
    x2: 216.07,
    y2: 65.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -5999.04,
    y1: -2657.91,
    x2: -5963.5,
    y2: -2657.91,
    gradientTransform: "translate(-5963.34 -2538.62) rotate(180)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "200.12 5.9 199.96 18.58 190.25 12.68 190.41 0 200.12 5.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "190.33 0 225.88 0.36 225.76 21.37 213.19 13.79 202.9 7.58 190.33 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "225.76 21.37 225.8 34.06 215.91 28.16 216.07 15.48 225.76 21.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "200.14 5.9 216.07 15.48 26.94 124.67 11.01 115.09 200.14 5.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "216.07 15.48 215.91 28.16 27.5 137.36 26.94 124.67 216.07 15.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "35.7 129.97 35.7 142.96 0 142.3 0.16 129.62 35.7 129.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "35.7 129.97 0.16 129.62 0.27 108.6 12.85 116.18 23.13 122.39 35.7 129.97"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M46.33,73.9l2.74,4.32v.14L46.29,80,43.92,76l-2.06,1.2v5.28L39.29,84l0-14.43,4.67-2.69c1.48-.86,2.63-1.14,3.43-.85s1.22,1.14,1.22,2.53A7,7,0,0,1,48,71.35,9.06,9.06,0,0,1,46.33,73.9Zm-.89-1.72A3.44,3.44,0,0,0,46,70.3c0-.68-.16-1.12-.5-1.31s-.86-.1-1.56.31l-2.07,1.19v4.34l2.09-1.21a4,4,0,0,0,1.5-1.44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M60.17,60.66A7,7,0,0,1,60.85,64v.65a12.9,12.9,0,0,1-.64,4.11,12,12,0,0,1-1.87,3.56,9.4,9.4,0,0,1-2.8,2.49,4.56,4.56,0,0,1-2.78.75,2.49,2.49,0,0,1-1.91-1.37,6.88,6.88,0,0,1-.69-3.29V70.2a12.64,12.64,0,0,1,.66-4.14,11.74,11.74,0,0,1,1.87-3.58A9.67,9.67,0,0,1,55.48,60a4.46,4.46,0,0,1,2.79-.75A2.45,2.45,0,0,1,60.17,60.66Zm-1.94,5.57v-.71a4.73,4.73,0,0,0-.72-3c-.47-.51-1.15-.52-2,0a4.84,4.84,0,0,0-2,2.32,9.34,9.34,0,0,0-.71,3.82v.71a4.87,4.87,0,0,0,.71,3c.48.54,1.16.56,2,0a4.93,4.93,0,0,0,2-2.33,9.57,9.57,0,0,0,.69-3.83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M72.37,53.61A7.35,7.35,0,0,1,73.05,57v.65a13.18,13.18,0,0,1-.64,4.11,12,12,0,0,1-1.87,3.56,9.65,9.65,0,0,1-2.8,2.49,4.57,4.57,0,0,1-2.79.75,2.48,2.48,0,0,1-1.9-1.37,6.87,6.87,0,0,1-.7-3.29v-.71A13.19,13.19,0,0,1,63,59a12.1,12.1,0,0,1,1.88-3.58A9.6,9.6,0,0,1,67.68,53a4.51,4.51,0,0,1,2.79-.74A2.48,2.48,0,0,1,72.37,53.61Zm-1.94,5.57v-.7a4.73,4.73,0,0,0-.72-3c-.48-.51-1.15-.52-2,0a4.88,4.88,0,0,0-2,2.33,9.31,9.31,0,0,0-.7,3.82v.71a4.62,4.62,0,0,0,.72,3c.46.55,1.15.57,2,.06a4.86,4.86,0,0,0,2-2.33,9.61,9.61,0,0,0,.7-3.84"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "88.13 41.36 88.17 55.79 85.57 57.29 85.56 53.34 85.79 46.39 82.43 59.1 80.66 60.12 77.25 51.33 77.53 57.98 77.54 61.93 74.95 63.42 74.91 48.99 78.29 47.04 81.55 55.64 84.72 43.32 88.13 41.36"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "108.83 29.4 106.09 45.44 103.48 46.95 101.41 38.47 99.39 49.31 96.79 50.81 93.96 37.99 96.54 36.5 98.27 45.77 100.31 34.33 102.5 33.06 104.59 42.14 106.25 30.89 108.83 29.4"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "112.98 27.01 113.02 41.44 110.44 42.93 110.4 28.5 112.98 27.01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124.25,23.8A5.87,5.87,0,0,1,125,27v.66a11.88,11.88,0,0,1-.71,4,12.3,12.3,0,0,1-2,3.6,10.69,10.69,0,0,1-3,2.58l-3.89,2.24,0-14.43,3.86-2.23a5.2,5.2,0,0,1,3-.85A2.54,2.54,0,0,1,124.25,23.8Zm-1.87,5.44v-.76c0-1.47-.27-2.43-.8-2.88s-1.3-.39-2.32.2l-1.28.74,0,9.63,1.25-.72A5.85,5.85,0,0,0,121.57,33a8.43,8.43,0,0,0,.81-3.73"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.58 13.96 135.58 16.37 131.74 18.59 131.77 30.61 129.19 32.11 129.15 20.08 125.36 22.27 125.35 19.87 135.58 13.96"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.27 7.21 147.31 21.64 144.73 23.13 144.71 16.95 139.67 19.86 139.69 26.05 137.09 27.54 137.05 13.11 139.64 11.62 139.66 17.46 144.7 14.55 144.69 8.7 147.27 7.21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnRoomWidth);
export default __webpack_public_path__ + "static/media/en-room-width.aeba9731dfd6dc6330ae73ce2824a9b0.svg";
export { ForwardRef as ReactComponent };